import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.less'],
  standalone: false
})
export class ContentLayoutComponent implements OnInit {

  showBigLogo = true;

  constructor() { }

  ngOnInit() {
    this.showBigLogo = true;
  }

}
